import * as React from "react";
import { useState, useEffect } from "react";
import { MoneyDisplayHelper } from "../../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { PartLoading } from "../../../../../../../../react-core/Html/PartLoading";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { CurrencyCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { ChargesQuerySort } from "../../../../../../../../Wrap/Models/Domains/Transactions/Charges/ChargesQuerySort";
import { ChargesTransaction } from "../../../../../../../../Wrap/Models/Domains/Transactions/Charges/ChargesTransaction";
import { Alert } from "../../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../../Shared/Entities/Constants/AlertConstants";
import { Table, sortDirection } from "../../../../../../../Shared/Table/Table";
import { chargeInfoText, getNoDataMsg } from "../Resource/Contents";

interface IChargesProps {
    data: ChargesTransaction[];
    onTableChange: (sortBy, orderBy) => void;
}

export const Charges = (props: IChargesProps) => {
    const [sortBy, setSortBy] = useState(ChargesQuerySort.Date);
    const [dateOrderByAESC, setDateOrder] = useState(false);
    const [amountOrderByAESC, setAmountOrder] = useState(false);
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(false);
    }, [props.data]);

    if (!props.data) {return null;}
    if (props.data && props.data.length == 0)
        {return <Alert alertType={AlertType.Warning} message={getNoDataMsg("Charges")} />;}
    const getData = (sortBy, orderByAESC) => {
        setLoading(true);
        props.onTableChange(sortBy, orderByAESC);
    };
    if (isLoading) {return <PartLoading isLoading={true} />;}

    const getMoneyFormat = (val: number): string => {
        let formatMoney = MoneyDisplayHelper.FromatMoneyDisplay(Math.abs(val), CurrencyCode.GBP);
        if (val < 0) {
            formatMoney = "-" + formatMoney;
        }
        return formatMoney;
    };

    return (
        <div>
            <Alert alertType={AlertType.Warning} message={chargeInfoText.text} />
            <div>
                <Table
                    data={props.data}
                    cssWrapper="has-sticky-header"
                    col={[
                        {
                            title: "Date",
                            key: "LedgerDate",
                            thCssWrapper: "ctable-sort",
                            render: (data, row, index) => {
                                return JsonDateParser.getFormatDate(data, "dd/MM/yyyy");
                            },
                            sorter: () => {
                                if (sortBy !== ChargesQuerySort.Date) {
                                    setSortBy(ChargesQuerySort.Date);
                                }
                                setDateOrder(!dateOrderByAESC);
                                getData(ChargesQuerySort.Date, !dateOrderByAESC);
                            },
                            sortDirection: dateOrderByAESC ? sortDirection.ASC : sortDirection.DESC,
                        },
                        {
                            title: "Charge Type",
                            key: "ChargeType",
                        },
                        {
                            title: "Amount",
                            key: "Amount",
                            thCssWrapper: "cell-right ctable-sort",
                            tdCssWrapper: "cell-right",
                            render: (data, row, index) => {
                                return getMoneyFormat(data);
                            },
                            sorter: () => {
                                if (sortBy !== ChargesQuerySort.Amount) {
                                    setSortBy(ChargesQuerySort.Amount);
                                }
                                setAmountOrder(!amountOrderByAESC);
                                getData(ChargesQuerySort.Amount, !amountOrderByAESC);
                            },
                            sortDirection: amountOrderByAESC ? sortDirection.ASC : sortDirection.DESC,
                        },
                    ]}
                    TotalBody={[
                        { data: "Total", colSpan: 2 },
                        {
                            data: getMoneyFormat(
                                props.data.reduce((total, ele) => {
                                    return total + ele.Amount;
                                }, 0)
                            ),
                            tfTdCssWrapper: "cell-right",
                        },
                    ]}
                />
            </div>
        </div>
    );
};
